import { ConsentCategoriesResolver } from "../types";
import { oneTrustCategoriesMap } from "./apiConsentResolver";

export class OnetrustCookieConsentResolver
  implements ConsentCategoriesResolver
{
  constructor(
    private readonly optIn: boolean,
    private cookiesManager: CookiesManager,
  ) {}

  available(): boolean {
    return this.cookiesManager.get("OptanonConsent") !== undefined;
  }

  ready(): boolean {
    return (
      !this.optIn ||
      this.cookiesManager.get("OptanonAlertBoxClosed") !== undefined
    );
  }

  resolve(): Categories {
    const groups = decodeURIComponent(
      this.cookiesManager.get("OptanonConsent"),
    )?.match(/groups=([^&]+)/);

    if (groups && groups[1]) {
      return groups[1]
        .toUpperCase()
        .split(",")
        .map((g) => {
          const nameVal = g.split(":");
          return nameVal[1] === "1"
            ? oneTrustCategoriesMap[nameVal[0]]
            : undefined;
        })
        .filter((c) => c)
        .reduce((a, v) => ({ ...a, [v]: true }), {});
    }
    return {};
  }
}
